import React, { useState, useEffect } from "react";
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, DatePicker, TimePicker } from "@material-ui/pickers";
import { makeStyles, Popover, Tabs, Tab, Button, useMediaQuery } from "@material-ui/core";
import { customTheme } from "../customTheme";
import moment from "moment";
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import notify from "./CustomUseNotify";
// import EventNoteIcon from '@material-ui/icons/EventNote';
// import DateRangeIcon from '@material-ui/icons/DateRange';
// import Chip from '@material-ui/core/Chip';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'flex-start',
        columnGap: 10, 
        rowGap: 10
      },
      chip: {
        margin: customTheme.spacing(0.5),
        fontFamily: 'Poppins-Medium',
        fontSize:12
      },
    defaultSelector: {
        borderRadius: 5,
        backgroundColor: "#f2f2f2",
        color: "#888",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        columnGap: 8,
        padding: "0px 20px",
        height: 44
    },
    activeSelector: {
        backgroundColor: customTheme.palette.primary.main + "19",
        color: customTheme.palette.primary.main
    },
    ampmSelector: {
        position: "absolute",
        bottom: 10,
        width: 38,
        height: 38,
        borderRadius: 100,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: 15,
        "&:hover": {
            cursor: "pointer"
        }
    }
});

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            hidden={value !== index}
            {...other}
        >
            {value === index && children}
        </div>
    );
}

 function DateTimePicker(props) {
    const classes = useStyles();
    const { initialDateRange, onChange, onDismiss } = props;
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));
    const [startDateTime, setStartDateTime] = useState(initialDateRange && initialDateRange.startDateTime ? initialDateRange.startDateTime : new Date());
    const [endDateTime, setEndDateTime] = useState(initialDateRange && initialDateRange.endDateTime ? initialDateRange.endDateTime : new Date());
    const [currentPicker, setCurrentPicker] = useState(0);

    const startDateTimeMoment = moment(startDateTime);
    const endDateTimeMoment = moment(endDateTime);

    const startTimeAm = startDateTimeMoment.format("A") === "AM";
    const endTimeAm = endDateTimeMoment.format("A") === "AM";

    const toggleStartDateTimeAmPm = () => {
        startDateTimeMoment.add(startTimeAm ? 12 : -12, 'h');
        setStartDateTime(startDateTimeMoment.toDate());
    };

    const toggleEndDateTimeAmPm = () => {
        endDateTimeMoment.add(endTimeAm ? 12 : -12, 'h');
        setEndDateTime(endDateTimeMoment.toDate());
    };

    const handleRangeChange = () => {
        if(moment(startDateTime).isAfter(endDateTime)) return notify("End Date & Time should always be after Start Date & Time", "info")
        onChange({ startDateTime, endDateTime });
        onDismiss();
    };

    return (
        <div className="customPickersStyles">
            <Tabs
                value={currentPicker}
                onChange={(event, newValue) => setCurrentPicker(newValue)}
                indicatorColor="primary"
                textColor="primary"
                variant="fullWidth"
            >
                <Tab
                    label={<div>
                        Start
                        <div style={{ fontWeight: 400 }}>{startDateTimeMoment.format("DD/MM/YYYY h:mm:ss A")}</div>
                    </div>}
                />
                <Tab
                    label={<div>
                        End
                        <div style={{ fontWeight: 400 }}>{endDateTimeMoment.format("DD/MM/YYYY h:mm:ss A")}</div>
                    </div>}
                />
            </Tabs>
            <TabPanel value={currentPicker} index={0} style={{ display: "flex", flexWrap: isSmallDevice ? 'wrap' : 'nowrap', justifyContent: "center", alignItems: "center" }}>
                <DatePicker
                    disableToolbar
                    variant="static"
                    value={startDateTime}
                    onChange={setStartDateTime}
                />
                <div style={{ position: "relative" }}>
                    <TimePicker
                        disableToolbar
                        variant="static"
                        value={startDateTime}
                        onChange={setStartDateTime}
                        views={['hours', 'minutes', 'seconds']}
                    />
                    <div onClick={!startTimeAm ? toggleStartDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ left: 15, color: startTimeAm ? "#fff" : "#222", backgroundColor: startTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>AM</div>
                    <div onClick={startTimeAm ? toggleStartDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ right: 15, color: !startTimeAm ? "#fff" : "#222", backgroundColor: !startTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>PM</div>
                </div>
            </TabPanel>
            <TabPanel value={currentPicker} index={1} style={{ display: "flex", flexWrap: isSmallDevice ? 'wrap' : 'nowrap', justifyContent: "center", alignItems: "center" }}>
                <DatePicker
                    disableToolbar
                    variant="static"
                    value={endDateTime}
                    onChange={setEndDateTime}
                />
                <div style={{ position: "relative" }}>
                    <TimePicker
                        disableToolbar
                        variant="static"
                        value={endDateTime}
                        onChange={setEndDateTime}
                        views={['hours', 'minutes', 'seconds']}
                    />
                    <div onClick={!endTimeAm ? toggleEndDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ left: 15, color: endTimeAm ? "#fff" : "#222", backgroundColor: endTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>AM</div>
                    <div onClick={endTimeAm ? toggleEndDateTimeAmPm : undefined} className={classes.ampmSelector} style={{ right: 15, color: !endTimeAm ? "#fff" : "#222", backgroundColor: !endTimeAm ? customTheme.palette.primary.main : customTheme.palette.grey[300] }}>PM</div>
                </div>
            </TabPanel>
            <div style={{ padding: "8px 10px", textAlign: "right", marginTop: 10 }}>
                <Button color="inherit" onClick={onDismiss} style={{ marginRight: 10, color: "#666" }}>Cancel</Button>
                <Button color="primary" onClick={handleRangeChange}>Done</Button>
            </div>
        </div >
    );
}


export default function CustomDateTimePicker(props) {
    const { startDateTime, setStartDateTime, endDateTime, setEndDateTime, onChange, limitDataRange, showOnlyCustomPicker = false, hideCurrentDate= false, hideCustomDate= false, showLast30Days = false, defaultTime = true, style} = props;
    const PIKCER_TYPES = { DATE: "Day", MONTH: "Month", CUSTOM: "Custom" };
    if(hideCurrentDate) delete PIKCER_TYPES.DATE
    if(hideCustomDate) delete PIKCER_TYPES.CUSTOM
    if(showLast30Days) PIKCER_TYPES.LAST30DAYS = 'Last 30 days'

    const classes = useStyles();
    const isSmallDevice = useMediaQuery(theme => customTheme.breakpoints.down("xs"));

    const [pickerType, setPickerType] = useState(showOnlyCustomPicker ? PIKCER_TYPES.CUSTOM : showLast30Days ? PIKCER_TYPES.LAST30DAYS : PIKCER_TYPES.DATE);
    const [anchorEl, setAnchorEl] = useState(null);
    const [showToday, setShowToday] = useState(false);

    const closePicker = () => {
        setAnchorEl(null);
    };

    const setDate = (dateMoment) => {
        let hours = 0, minutes = 0, seconds = 0;
        const timeStr = sessionStorage.getItem("summary_start_time");
        if (typeof timeStr === "string" && timeStr !== "" && timeStr !== "null" && timeStr !== "undefined") {
            const parsedTime = moment(timeStr, "HH:mm:ss");
            if (parsedTime.isValid()) {
                hours = parsedTime.hours();
                minutes = parsedTime.minutes();
                seconds = parsedTime.seconds();
                if (dateMoment.isSame(moment(), 'day') && (dateMoment.isBefore(parsedTime, 'hour') || dateMoment.isSame(parsedTime, 'hour'))) {
                    dateMoment = dateMoment.subtract(1, 'day');
                    setShowToday(true)
                }else setShowToday(false)
            }
        }

        if (showLast30Days) last30DaysHandler()
        else {
            setStartDateTime(moment(dateMoment).utcOffset("+05:30").set({ hour: hours, minute: minutes, second: seconds }).toDate());
            setEndDateTime(moment(dateMoment).utcOffset("+05:30").set({ hour: hours, minute: minutes, second: seconds }).add({ hours: 23, minutes: 59, seconds: 59 }).toDate());
        }
    };

    const setMonth = (dateMoment) => {
        let hours = 0, minutes = 0, seconds = 0;
        const timeStr = sessionStorage.getItem("summary_start_time");
        if (typeof timeStr === "string" && timeStr !== "" && timeStr !== "null" && timeStr !== "undefined") {
            const parsedTime = moment(timeStr, "HH:mm:ss");
            if (parsedTime.isValid()) {
                hours = parsedTime.hours();
                minutes = parsedTime.minutes();
                seconds = parsedTime.seconds();
            }
        }

		setStartDateTime(moment(dateMoment, "YYYY-MM-DD HH:mm:ss").startOf("month").set({ hour: hours, minute: minutes, second: seconds }).format("YYYY-MM-DD HH:mm:ss"));
		setEndDateTime(moment(dateMoment, "YYYY-MM-DD HH:mm:ss").endOf("month").set({ hour: hours, minute: minutes, second: seconds }).add({hours: 23,minutes: 59,seconds: 59}).format("YYYY-MM-DD HH:mm:ss"));
    };

    const onListItemClick = (type) =>{
        setPickerType(type)
        if(showLast30Days && type === 'Last 30 days'){
            last30DaysHandler()
            closePicker()
        }
    };

    const getDisplayText = () => {
        switch (pickerType) {
            case PIKCER_TYPES.DATE:
                return startDateTime ?
                    moment(startDateTime).calendar(null, {
                        sameDay: '[Today]',
                        nextDay: '[Tomorrow]',
                        nextWeek: "Do MMM' YY",
                        lastDay: '[Yesterday]',
                        lastWeek: "Do MMM' YY",
                        sameElse: "Do MMM' YY"
                    })
                :
                    moment().calendar(null, {
                        sameDay: '[Today]',
                        nextDay: '[Tomorrow]',
                        nextWeek: "Do MMM' YY",
                        lastDay: '[Yesterday]',
                        lastWeek: "Do MMM' YY",
                        sameElse: "Do MMM' YY"
                    });
            case PIKCER_TYPES.MONTH:
                return startDateTime ? moment(startDateTime).format("MMM' YY") : moment().format("MMM' YY");
            case PIKCER_TYPES.CUSTOM || PIKCER_TYPES.LAST30DAYS:
                return startDateTime && endDateTime ?
                    `${moment(startDateTime).format("DD/MM/YYYY h:mm:ss A")} - ${moment(endDateTime).format("DD/MM/YYYY h:mm:ss A")}`
                :
                    `${moment().set({ hours: 0, minutes: 0, seconds: 0 }).format("DD/MM/YYYY h:mm:ss A")} - ${moment().set({ hours: 23, minutes: 59, seconds: 59 }).format("DD/MM/YYYY h:mm:ss A")}`
            default:
                return PIKCER_TYPES[pickerType]
        }
    };

    const last30DaysHandler = () =>{
        let hours = 0, minutes = 0, seconds = 0;
        const timeStr = sessionStorage.getItem("summary_start_time");
        if (typeof timeStr === "string" && timeStr !== "" && timeStr !== "null" && timeStr !== "undefined") {
            const parsedTime = moment(timeStr, "HH:mm:ss");
            if (parsedTime.isValid()) {
                hours = parsedTime.hours();
                minutes = parsedTime.minutes();
                seconds = parsedTime.seconds();
            }
        }
        setStartDateTime(moment().utcOffset("+05:30").clone().subtract(30, 'days').set({hour: hours,minute: minutes,second: seconds}).toDate());
        setEndDateTime(moment().utcOffset("+05:30").set({hour: hours,minute: minutes,second: seconds}).add({hours: 23,minutes: 59,seconds: 59}).toDate());
    }

    useEffect(() => {
       if(defaultTime) setDate(moment())
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        onChange();
    }, [startDateTime, endDateTime]); // eslint-disable-line react-hooks/exhaustive-deps

    const displayText = getDisplayText();
    const makeTextScrollable = displayText.length > 12;

    return (<>
        <div style={{ display: "flex", columnGap: 20, margin: isSmallDevice ? "0px 0px 0px 0px" : "0px 0px 0px 0px", padding: isSmallDevice ? "0px 0px" : "0 0", flexWrap: "wrap", rowGap: isSmallDevice ? 10 : 20, ...style }}>
           
            <div
                onClick={event => setAnchorEl(event.currentTarget)}
                className={`divButton ${classes.defaultSelector} ${classes.activeSelector}`}
            >
                <CalendarTodayIcon style={{ fontSize: 16 }} />

                {!showOnlyCustomPicker && <div className="fontWeightMedium" style={{ fontSize: 12 }}>
                    <div className="scrolling-container" style={{width: makeTextScrollable ? 80 : ""}}>
                        <div className={makeTextScrollable ? "scrolling-text" : ""}>
                            {showToday ? 'Today' : displayText}
                        </div>
                    </div>
                </div>}

                {showOnlyCustomPicker && <div className="fontWeightMedium" style={{ fontSize: 12 }}>
                    {pickerType === PIKCER_TYPES.CUSTOM &&
                            startDateTime && endDateTime ?
                            `${moment(startDateTime).format("DD/MM/YYYY h:mm:ss A")} - ${moment(endDateTime).format("DD/MM/YYYY h:mm:ss A")}` : `${moment().set({ hours: 0, minutes: 0, seconds: 0 }).format("DD/MM/YYYY h:mm:ss A")} - ${moment().set({ hours: 23, minutes: 59, seconds: 59 }).format("DD/MM/YYYY h:mm:ss A")}`
                    }
                </div>}
            </div> 
        </div>

        <MuiPickersUtilsProvider utils={DateFnsUtils}>

        <Popover
                open={Boolean(anchorEl)}
                anchorEl={anchorEl}
                onClose={closePicker}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                transformOrigin={{ vertical: "top", horizontal: "left" }}
                style={{ marginTop: 15, width: isSmallDevice ? "100%" : "auto"}}
                id='custom-date-time-picker-v2'
            >
                <div style={{ display: !isSmallDevice ? 'flex' : 'block', justifyContent: 'flex-start', backgroundColor:'#F5F8FA', padding: !isSmallDevice ? 20 : "20px 20px 150px 20px", columnGap: 20, rowGap:20 }}>
                    {!isSmallDevice ? 
                    <div>
                    {/* <Typography style={{ marginBottom: 10, fontSize:15, textAlign:'center', color: customTheme.palette.primary.main }}>Date Preset</Typography> */}
                        {Object.keys(PIKCER_TYPES).filter((type) => showOnlyCustomPicker && type === 'CUSTOM' ? type : !showOnlyCustomPicker ? type : false).map((value, i) => {
                            return (
                                <div>
                                    <Button
                                        onClick={() => onListItemClick(PIKCER_TYPES[value])}
                                        variant="contained"
                                        style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", minWidth: "120px", backgroundColor: pickerType === PIKCER_TYPES[value] ? '#707683' : '#FFFFFF', color: pickerType === PIKCER_TYPES[value] ? '#FFFFFF' : "#90A0B7", marginBottom: 20, cursor: 'pointer', height: 45, borderRadius: 10, fontWeight:500 }}
                                        disableElevation
                                        startIcon={<CalendarTodayIcon style={{ fontSize: 16 }} />}
                                    >
                                        {PIKCER_TYPES[value]}
                                    </Button>
                                </div>
                            );
                        })}
                    </div>
                    : 
                        <div style={{backgroundColor: '#F5F8FA', padding: 10}}>
                            {/* <Typography style={{ marginBottom: 10, fontSize: 15, textAlign: 'center', color: customTheme.palette.primary.main }}>Date Preset</Typography> */}
                            <div className={classes.root}>
                                {Object.keys(PIKCER_TYPES).filter((type) => showOnlyCustomPicker && type === 'CUSTOM' ? type : !showOnlyCustomPicker ? type : false).map((value, i) => {
                                    return (
                                        <div>
                                        <Button
                                            onClick={() => onListItemClick(PIKCER_TYPES[value])}
                                            variant="contained"
                                            style={{ textTransform: "none", fontSize: 13, fontFamily: "Poppins-Regular", letterSpacing: "0.06em", backgroundColor: pickerType === PIKCER_TYPES[value] ? '#707683' : '#FFFFFF', color: pickerType === PIKCER_TYPES[value] ? '#FFFFFF' : "#90A0B7", marginBottom: 20, cursor: 'pointer', height: 45, borderRadius: 10, fontWeight:500 }}
                                            disableElevation
                                            startIcon={<CalendarTodayIcon style={{ fontSize: 16 }} />}
                                        >
                                            {PIKCER_TYPES[value]}
                                        </Button>
                                    </div>
                                    );
                                })}
                            </div>
                    </div>
                    
}
                    {pickerType === PIKCER_TYPES.CUSTOM && <DateTimePicker
                        initialDateRange={{ startDateTime: startDateTime, endDateTime: endDateTime }}
                        onChange={dateRange => {
                            setStartDateTime(dateRange.startDateTime);
                            setEndDateTime(dateRange.endDateTime);
                            closePicker();
                        }}
                        onDismiss={closePicker}
                    />}
                    {!showOnlyCustomPicker && pickerType === PIKCER_TYPES.MONTH &&
                    <div className="customPickersStyles">
                        <DatePicker
                            variant="static"
                            minDate={limitDataRange > 0 ? moment().subtract(limitDataRange - 1, "days").toDate() : undefined}
                            disableFuture
                            disableToolbar={pickerType !== PIKCER_TYPES.MONTH}
                            value={startDateTime}
                            onChange={(date) => {
                                const dateMoment = moment(date);
                                if (pickerType === PIKCER_TYPES.MONTH) {
                                    setMonth(dateMoment);
                                }
                                closePicker();
                            }}
                            views={["month", "year"]}
                        />
                        </div>
                    }
                    {!showOnlyCustomPicker && pickerType === PIKCER_TYPES.DATE &&
                        <div className="customPickersStyles">
                            <DatePicker
                            variant="static"
                            minDate={limitDataRange > 0 ? moment().subtract(limitDataRange - 1, "days").toDate() : undefined}
                            disableFuture
                            disableToolbar={pickerType !== PIKCER_TYPES.MONTH}
                            value={startDateTime}
                            onChange={(date) => {
                                const dateMoment = moment(date);
                                if (pickerType === PIKCER_TYPES.DATE) {
                                    setDate(dateMoment);
                                }
                                closePicker();
                            }}
                            views={["year", "month", "date"]}
                        />
                        </div>
                    }
                </div>
            </Popover>
        </MuiPickersUtilsProvider>
    </>);
}